import React, {useState, useEffect} from 'react';
import {Box, Stack, Grid} from '@mui/material';
import {ICheckboxListItem} from '../../../../../../shared/types';
import ArrCheckboxList from '../../../../../common/arr-checkbox-list/ArrCheckboxList';
import ArrLoadingSpinner from '../../../../../common/arr-loading-spinner/ArrLoadingSpinner';
import {useFieldData} from '../../../../../../hooks/session-search/useSessionSearch';
import {FieldTypeProps} from '../FieldTypeProps';
import './SecurityGroupType.scss';
import '../FieldTypes.scss';

export interface SecurityGroupsTypeProps
  extends Omit<FieldTypeProps, 'onCriteriaChaged'> {
  onCriteriaChaged?: (value: string[]) => void;
}

const SecurityGroupType: React.FC<SecurityGroupsTypeProps> = ({
  type = 'SECURITYGROUPS',
  onCriteriaChaged,
  onValidated,
}) => {
  const {data, isLoading} = useFieldData(type);
  const [checkboxItems, setCheckboxItems] = useState<ICheckboxListItem[]>([]);
  const [, setSelectedGroups] = useState<string[]>([]);
  useEffect(() => {
    if (!data?.workProductItemsDetails) return;
    const formatted = data.workProductItemsDetails.map((item) => ({
      label: item.text ?? '',
      value: false,
    }));
    setCheckboxItems(formatted);
    setSelectedGroups([]);
    onValidated?.(false);
    onCriteriaChaged?.([]);
  }, [data]);

  const handleCheckboxListChange = (checked: boolean[]) => {
    const selected = checkboxItems.filter((_, i) => checked[i]);
    const labels = selected.map((s) => s.label);

    onCriteriaChaged?.(labels);
    onValidated?.(labels.length > 0);
  };

  return (
    <Grid
      container
      direction="column"
      spacing={5}
      className="security-group-panel"
    >
      <Stack spacing={1}>
        <Grid className="security-group-panel_left-pane">
          <Box>
            <ArrCheckboxList
              childLabels={checkboxItems}
              onChange={handleCheckboxListChange}
              showSelectAll={true}
              size="small"
            />
          </Box>

          <Box>
            <ArrLoadingSpinner show={isLoading} />
          </Box>
        </Grid>
      </Stack>
    </Grid>
  );
};

export default SecurityGroupType;
